import { Button, ButtonProps } from '@mui/material';

const QrButton = ({ sx, ...props }: ButtonProps) => {
  const styles = sx ? [...(Array.isArray(sx) ? sx : [sx])] : [];
  return (
    <Button
      variant="contained"
      {...props}
      sx={[
        ...styles,
        {
          fontSize: { xs: '1.75rem', md: '3rem' },
          minWidth: '9ch',
          lineHeight: 'normal',
        },
      ]}
    />
  );
};

export default QrButton;
